





















import { DateTime } from 'luxon';
import { Component, Vue } from 'vue-property-decorator';
import hexabaseState from '@/store/hexabase';
import ConstructionModel from '@/models/constructionModel';
import SearchPanelComponent from '@/components/construction/constructionsearch/SearchPanelComponent.vue';
import ItemList from '@/components/construction/constructionsearch/ItemList.vue';
import { GetItemsResponse, FieldChildrenProp } from '@/services/hexabase/types';
import { listPerPage } from '@/constants/util';
import constructionState from '@/store/construction';
import { searchFormConstruct } from '@/constants/form/search';

@Component({
  components: {
    SearchPanelComponent,
    ItemList
  }
})
export default class ConstructionList extends Vue {
  private constructionModel = new ConstructionModel();
  // マスタデータ関連格納プロパティ
  private masterData: { [k: string]: { [k: string]: Array<{ [k: string]: string }> } } = {};
  // アイテム取得時Param
  /* eslint-disable @typescript-eslint/camelcase */
  private payload = {
    conditions: [] as Array<{ [key: string]: string | string[] }>,
    per_page: listPerPage,
    page: 1,
    use_display_id: true,
    sort_fields: [] as Array<{ [key: string]: string }>
  };

  // 各入力フィールド情報格納プロパティ
  private searchFieldsData: Array<FieldChildrenProp> = [];
  private searchFieldsDataTmp: Array<FieldChildrenProp> = [];
  private searchFieldCols = '';
  private statusList: any = {};

  // 一覧表示部分に使用
  private fieldsData: any = {};
  private apiResponseData: GetItemsResponse = { items: [], totalItems: 0 };
  private colums: Array<{ [k: string]: string | number | boolean }> = [];
  /*
   * tableHeaderWithType
   * この変数を定義した目的
   *  (1) ヘッダーを生成する
   *  (2) カスタムソートのソートタイプを判別するためのtypeをヘッダーと紐づける
   *
   * name：hexabaseから取得したフィールドidとカラムを照合するための値
   * order：カラムの順番
   * width：カラムの幅
   * type：ソートタイプ（stringがデフォルト※通常の文字列）
   * ※typeを追加したい場合は、「customSort」に処理を追加する必要がある
   * ※ソートが不要な列に対しては、typeに''（空文字）を指定し、sortable:falseを追加する
   *
   */
  private tableHeaderWithType: Array<{
    name: string;
    order: number;
    width?: number;
    type: string;
    sortable?: boolean;
  }> = [
    { name: 'fiscal_year', order: 2, width: 50, type: 'number' },
    { name: 'construction_management_no', order: 3, type: 'construction_management_no' },
    { name: 'title_disp', order: 4, type: 'string' },
    { name: 'customer_name', order: 5, type: 'string' },
    { name: 'construction_division_name', order: 6, type: 'string' }
  ];
  private readonly customSort: Function = (
    items: any[],
    sortByDatas: string[],
    isDescDatas: boolean[]
  ) => {
    const sortBy: string = sortByDatas[0]; // 列名
    const isDesc: boolean = isDescDatas[0]; //降順：true, 昇順：false
    const tableColumnWithType = this.tableHeaderWithType.find(v => v.name === sortBy);

    items.sort((a, b) => {
      let sort = 1;

      if (a[sortBy] === b[sortBy]) {
        sort = 0;
      } else if (tableColumnWithType?.type === 'construction_management_no') {
        const a_split = a[sortBy].split('-'); // 値の例：['62', '487', '7']
        const b_split = b[sortBy].split('-');

        // 左から順に比較(期→工事番号→工事科目の順に比較)
        if (a_split[0] == b_split[0]) {
          if (a_split[1] == b_split[1]) {
            if (Number(a_split[2]) < Number(b_split[2])) {
              sort = -1;
            }
          } else {
            if (Number(a_split[1]) < Number(b_split[1])) {
              sort = -1;
            }
          }
        } else {
          if (Number(a_split[0]) < Number(b_split[0])) {
            sort = -1;
          }
        }
      } else if (tableColumnWithType?.type === 'number') {
        // 空の場合は、昇順・降順に関わらず下へソート
        if (a[sortBy] === undefined && b[sortBy] === undefined) return 0;
        if (a[sortBy] === '' || a[sortBy] === undefined) return 1;
        if (b[sortBy] === '' || b[sortBy] === undefined) return -1;

        // 数値として比較
        if (Number(a[sortBy]) < Number(b[sortBy])) {
          sort = -1;
        }
      } else if (tableColumnWithType?.type === 'date') {
        // 空の場合は、昇順・降順に関わらず下へソート
        if (a[sortBy] === undefined && b[sortBy] === undefined) return 0;
        if (a[sortBy] === '' || a[sortBy] === undefined) return 1;
        if (b[sortBy] === '' || b[sortBy] === undefined) return -1;

        // 整形が必要な日付フォーマットを整形（例：2022-01だったら2022-01-01にする）
        const regex = new RegExp(/^\d{4}-\d{2}$/);
        let formatedA = a[sortBy];
        let formatedB = b[sortBy];
        if (regex.test(a[sortBy])) formatedA = a[sortBy] + '-01';
        if (regex.test(b[sortBy])) formatedB = b[sortBy] + '-01';

        const formatedAForCompare = DateTime.fromISO(formatedA);
        const formatedBForCompare = DateTime.fromISO(formatedB);

        // 日付として比較
        if (formatedAForCompare < formatedBForCompare) {
          sort = -1;
        }
      } else {
        // その他('string'も同様)
        if (typeof a[sortBy] !== 'undefined' && typeof b[sortBy] !== 'undefined') {
          if (a[sortBy].toLowerCase().localeCompare(b[sortBy].toLowerCase()) < 0) {
            sort = -1;
          }
        }
      }

      // 降順の場合はソート順を反転
      if (!isDesc) {
        return sort;
      } else {
        return sort * -1;
      }
    });
    return items;
  };

  private page = {
    currentPage: 1,
    totalPage: 1,
    totalItem: 0,
    visible: 8,
    perPage: listPerPage
  };

  async created() {
    // マスターデータを取得しグローバル変数に格納
    await this.constructionModel.getMasterData();
    this.masterData = this.constructionModel.getMaster();
    // 自動生成コンポーネント用にプロパティー設定
    this.fieldsData = await this.constructionModel.getField(
      hexabaseState.applicationId,
      hexabaseState.datastoreIds['工事']
    );
    this.fieldsData.fields['construction_management_no'] = {};
    this.fieldsData.fields['construction_management_no']['name'] = '工事管理番号';
    this.fieldsData.fields['construction_management_no']['display_id'] =
      'construction_management_no';
    this.fieldsData.fields['customer_name'] = {};
    this.fieldsData.fields['customer_name']['name'] = '元請名';
    this.fieldsData.fields['customer_name']['display_id'] = 'customer_name';
    this.fieldsData.fields['construction_division_name'] = {};
    this.fieldsData.fields['construction_division_name']['name'] = '工事部門';
    this.fieldsData.fields['construction_division_name']['display_id'] = 'construction_division_name';
    this.searchFieldsData = await this.constructionModel.createSearchConf(
      this.fieldsData,
      this.masterData
    );
    // 検索フォーム定義分のみ画面描画
    this.searchFieldsData.forEach((item: any) => {
      let marchFlg = false;
      searchFormConstruct.forEach((item2: any) => {
        if (item.display_id === item2.display_id) marchFlg = true;
      })
      if (marchFlg) this.searchFieldsDataTmp.push(item);
    });
    this.searchFieldsData = this.searchFieldsDataTmp;
    this.searchFieldCols = `8.3% `.repeat(12); //検索フォームは表示を均等にするため固定

    let initSearchConditions = undefined;
    if (constructionState.searchConditions.length != 0) {
      const searchConditions = constructionState.searchConditions.splice(0);
      // 検索条件が保持されている場合、フォームに復元する
      for (const condition of searchConditions) {
        const field = this.searchFieldsData.find(e => e.display_id === condition.id);
        if (field !== undefined) {
          switch (field.dataType) {
            case 'dslookup':
              field.props!.value = { item_id: condition.search_value[0] };
              break;
            case 'datetime':
              field.props!.valueFrom = condition.search_value[0];
              field.props!.valueTo = condition.search_value[1];
              break;
            case 'status':
            default:
              field.props!.value = condition.search_value[0];
              break;
          }
        }
      }
      initSearchConditions = searchConditions;
    }
    // 初期表示データ取得
    await this.getItems(initSearchConditions);
    this.colums = this.createColums();
  }

  async getItems(condition?: Array<{ [key: string]: string | string[] }>, page?: number) {
    if (condition !== undefined && condition.length > 0) {
      this.payload['conditions'] = condition;
      // storeに検索条件を保持
      constructionState.setSearchConditions(condition);
    }
    this.payload['page'] = page !== undefined ? page : 1;
    this.payload['sort_fields'] = [
      { id: 'period', order: 'desc' },
      { id: 'construction_no', order: 'desc' },
      { id: 'construction_subject_id', order: 'desc' }
    ];
    this.apiResponseData = await this.constructionModel.getItemSearch(
      hexabaseState.applicationId,
      hexabaseState.datastoreIds['工事'],
      this.payload
    );
    for (const key in this.apiResponseData.items) {
      this.apiResponseData.items[key]['construction_management_no'] =
        this.apiResponseData.items[key]['period'] +
        '-' +
        this.apiResponseData.items[key]['construction_no'] +
        '-' +
        this.apiResponseData.items[key]['construction_subject_id'];
      this.apiResponseData.items[key]['customer_name'] = this.getMasterName('m_customer', String(this.apiResponseData.items[key].customer_id));
      this.apiResponseData.items[key]['construction_division_name'] = this.getMasterName('m_department', String(this.apiResponseData.items[key].construction_division_id));
    }
    // アイテム数等をセット
    (this.page.totalItem = this.apiResponseData.totalItems), listPerPage;
    this.page.totalPage = this.getTotalPage(this.apiResponseData.totalItems, listPerPage);
    this.page.currentPage = this.payload['page'];
  }

  private getTypes() {
    const fieldsType: { [k: string]: string } = {};
    for (const i in this.searchFieldsData) {
      fieldsType[this.searchFieldsData[i].display_id] = this.searchFieldsData[i].dataType;
    }
    return fieldsType;
  }

  private createColums() {
    const columList: { [k: string]: string | number | boolean }[] = [];
    const allowedList: Array<{
      [k: string]: string | number | boolean;
    }> = this.tableHeaderWithType.map(v => {
      // tableHeaderWithTypeから必要な値だけ取り出してを生成する
      const forHeaderData: { [k: string]: any } = {
        name: v.name,
        order: v.order
      };
      if (v.width !== undefined) forHeaderData.width = v.width;
      if (v.sortable !== undefined) forHeaderData.sortable = v.sortable;
      return forHeaderData;
    });
    Object.keys(this.fieldsData.fields).forEach(key => {
      const find = allowedList.find(v => v.name === this.fieldsData.fields[key]['display_id']);
      if (find !== undefined) {
        columList.push({
          text: this.fieldsData.fields[key]['name'],
          value: this.fieldsData.fields[key]['display_id'],
          order: find.order,
          width: find.width ? find.width : ''
        });
        if (find.sortable !== undefined) {
          for (const column of columList) {
            if (column.value === find.name) {
              column.sortable = find.sortable;
            }
          }
        }
      }
    });
    return columList.sort((a, b) => {
      return a.order < b.order ? -1 : 1;
    });
  }

  public getTotalPage(totalItems: number, perPage: number): number {
    return Math.ceil(totalItems / perPage);
  }

  private resetsearchForm() {
    // 検索条件をクリア
    this.payload.conditions.splice(0);
    this.payload.page = 1;
    // storeに保持した検索条件をクリア
    constructionState.clearSearchConditions();
  }

  private pagenaviAction(response: any) {
    this.getItems(undefined, response);
  }

  private getMasterName(master: string, key: string): string {
    let masterName = '';
    const findData = this.masterData[master].body.find(
      v => String(v.id) === key
    );
    if (findData) {
      masterName = findData.name;
    }
    return masterName;
  }
}
